var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHaiti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.384-114.616 256-256 256s-256-114.616-256-256 256-256 256-256 256 114.616 256 256z",
    fill: "#a2001d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 256c0-141.384 114.616-256 256-256s256 114.616 256 256",
    fill: "#0052b4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m345.043 322.783-89.043-11.131-89.043 11.131v-133.566h178.086z",
    fill: "#f0f0f0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 267.13,
    fill: "#0052b4",
    r: 44.522
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 267.13,
    fill: "#a2001d",
    r: 22.261
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m222.609 211.478h66.782l-33.391 33.392z",
    fill: "#6da544"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m244.87 233.739h22.261v66.783h-22.261z",
    fill: "#ffda44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m291.617 293.843h-71.236l-53.424 28.94h178.086z",
    fill: "#6da544"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaiti);
export default __webpack_public_path__ + "static/media/haiti.bff2565b73e32b65de53d011995be973.svg";
export { ForwardRef as ReactComponent };